import React from "react"

interface Props {
  json: any
}

const JsonPrettyPrint: React.FC<Props> = ({ json }) => (
  <pre className="text-xs text-gray-500">
    <code>{JSON.stringify(json, Object.getOwnPropertyNames(json), 2)}</code>
  </pre>
)

export default JsonPrettyPrint
